module.exports = __webpack_public_path__ + "static/media/CAM-04.d2f488e9.webp";